import ComponentBase from "@components/ComponentBase";
import { ComponentElem } from "@components/interfaces";
import GS from "@ts/GlobalSetting";
import { Product } from "./ProductTypes";
import Tools from "@root/ts/Tools";

export default class ReviewRating extends ComponentBase
{
  static generate(elem: ComponentElem, data: {name: string, value: number})
  {
    // elem.setAttribute("data-max-value", String(GS.reviewMaxRating));
    $(elem).find(".name").text(data.name);
    $(elem).find(".score").text(Tools.parseFloat(String(data.value)).toFixed(1));

    return new ReviewRating(elem, Tools.parseFloat(data.value), GS.reviewMaxRating);
  }

  constructor(elem: ComponentElem, value: number, maxValue: number)
  {
    super(elem);

    let $valueProgress = this.$root.find(".value"),
    percent: number = value / maxValue,
    minPrecent = 2;
    
    $valueProgress.css("width", (minPrecent + (100 - minPrecent)*percent) + "%");
  }
}